<div class="wizzard-sub-nav">
    <div class="wizzard-sub-nav__inner">
        <ul class="wizzard-sub-nav__list" #items>
            <ng-container *ngFor="let page of menuFlowPages;trackBy: trackBy;let i = index">
                <li (click)="onItemClick($event, page.PageIdentifier)" class="wizzard-sub-nav__li"
                    id="wizzard-sub-nav-{{page.PageIdentifier}}"
                    [ngClass]="{'is-active': activePageIdentifier === page.PageIdentifier || activePageIdentifier === null && i === 0}">
                    <label class="wizzard-sub-nav__item-label">
                        {{page.PageName}}
                    </label>
                </li>
            </ng-container>
            <li class="wizzard-sub-nav__li -indicator" #indicator></li>
        </ul>
    </div>
</div>